import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as c from "../constant";
import Select from "react-select";
import JobInfoModal from "./JobInfoModal";
import moment from "moment-timezone";
import GovernmentSlider from "./GovernmentSlider";

import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

class JobseekerJobSearch extends PureComponent {
  componentWillMount() {
    const { dispatch } = this.props;
    dispatch({
      type: c.CLEAR_FORM_DATA,
    });
    dispatch({
      type: c.GET_JOBS,
      args: {},
    });
    dispatch({
      type: c.GET_COUNTRY,
    });
    dispatch({
      type: c.GET_CATEGORY,
    });
    dispatch({
      type: c.GET_CLIENT,
    });
  }

  handleOnChange = (e) => {
    e.preventDefault();
    const { dispatch } = this.props;
    const { name, value } = e.target;
    dispatch({
      type: c.SET_FORM_DATA,
      data: {
        [name]: value.toUpperCase(),
      },
    });
  };

  handleChangeInput = (e) => {
    e.preventDefault();
    const { dispatch } = this.props;
    const { name, value } = e.target;
    dispatch({
      type: c.SET_FORM_DATA,
      data: {
        [name]: value,
      },
    });
  };

  showInfo = (data) => (e) => {
    e.preventDefault();
    const { dispatch, history, match } = this.props;
    if (sessionStorage.getItem("token")) {
      dispatch({
        type: c.GET_JOB_DETAILS,
        id: data.get("id"),
      });
    }
    history.push(`/jobseeker/job/${data.get("id")}`);

    if (match.url !== "/")
      return history.push(`${match.url}/job/${data.get("id")}`);

    dispatch({
      type: "MODAL",
      data: {
        isOpen: true,
        title: data.get("title"),
        modalSize: "modal-lg",
        content: <JobInfoModal data={data} />,
      },
    });
  };

  search = (e) => {
    e.preventDefault();
    const { dispatch, form_data } = this.props;
    dispatch({
      type: c.CLEAR_LIST,
    });
    dispatch({
      type: c.GET_JOBS,
      args: {
        category: form_data.get("category"),
        clients: form_data.get("clients"),
        country: form_data.get("country"),
        search: form_data.get("search"),
      },
    });
  };

  handleOnClose = (e) => {
    e.preventDefault();
    const { dispatch } = this.props;
    dispatch({
      type: "MODAL",
      data: {
        isOpen: false,
      },
    });
  };

  handleChangeSelect = (key) => (e) => {
    const { dispatch } = this.props;
    dispatch({
      type: c.SET_FORM_DATA,
      data: {
        [key]: e || "",
      },
    });
  };

  moreJobs = (e) => {
    e.preventDefault();
    const { dispatch, jobs, meta, form_data } = this.props;
    dispatch({
      type: c.GET_JOBS,
      args: {
        category: form_data.get("category"),
        clients: form_data.get("clients"),
        country: form_data.get("country"),
        search: form_data.get("search"),
        page: +meta.get("from") + 1,
      },
      jobs: jobs.toJS(),
    });
  };

  render() {
    const { form_data, countries, categories, match, jobs } = this.props;

    return (
      <Fragment>
        <div className="container">
          <div className="page-content">
            <div className="inside-page-section">
              <div className="section-title mb-5 mt-5">
                <h2 className="text-center">Search Jobs</h2>
              </div>
              {this.getProps}

              <form onSubmit={this.search}>
                <div className="section-content mb-2">
                  <div className="row">
                    <div className="col-md-12 ">
                      <input
                        type="text"
                        name="search"
                        className="form-control"
                        placeholder="SEARCH JOBS / EMPLOYER"
                        value={form_data.get("search")}
                        onChange={this.handleChangeInput}
                      />
                    </div>
                  </div>
                </div>
                <div className="section-content dropdownarea">
                  <div className="row">
                    <div className="col-md-6 mb-2 pr-md-1">
                      <Select
                        className=""
                        value={form_data.get("category")}
                        simpleValue
                        onChange={this.handleChangeSelect("category")}
                        name="category"
                        loadingPlaceholder="Loading..."
                        options={categories.toJS().map((item) => {
                          return {
                            label: item.name,
                            value: item.id,
                          };
                        })}
                        placeholder="Select Category"
                      />
                    </div>

                    {/*
                            <div className="col-md-6">
                                <Select
                                className=""
                                value={ form_data.get('clients') }
                                simpleValue
                                onChange={this.handleChangeSelect('clients')}
                                name="clients"
                                loadingPlaceholder="Loading..."
                                placeholder="Select Employer"
                                options={clients.toJS().map( item => {
                                    return {
                                        label:item.company,
                                        value:item.id
                                    }}
                                )}/>
                            </div>
                            */}
                    <div className="col-md-6 mb-2 pl-md-1">
                      <Select
                        className=""
                        value={form_data.get("country")}
                        simpleValue
                        onChange={this.handleChangeSelect("country")}
                        name="country"
                        loadingPlaceholder="Loading..."
                        placeholder="Select Country"
                        options={countries.toJS().map((item) => {
                          return {
                            label: item.name,
                            value: item.id,
                          };
                        })}
                      />
                    </div>
                  </div>
                </div>
                <div className="section-content">
                  <div className="row">
                    <div className="col-md-12 mb-3 jobs-search-wrap">
                      <div className="input-group-append">
                        <button
                          className="btn btn-primary btn-block btn-large"
                          type="submit"
                        >
                          <i className="fas fa-search"></i>{" "}
                          <span className="btn-text">FIND JOBS</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="mb-5 pb-5 _inside">
            <div className="custom-table table-responsive clearfix">
              <Table className="table table-striped">
                <Thead>
                  <Tr>
                    <Th
                      className="text-bold"
                      style={{
                        whiteSpace: "nowrap",
                        borderTop: "none",
                        paddingLeft: 20 + "px",
                      }}
                    >
                      JOB
                    </Th>
                    <Th
                      className="text-bold"
                      style={{ whiteSpace: "nowrap", borderTop: "none" }}
                    >
                      EMPLOYER
                    </Th>
                    <Th
                      className="text-bold "
                      style={{ whiteSpace: "nowrap", borderTop: "none" }}
                    >
                      EXPIRY DATE
                    </Th>
                    <Th
                      className="text-bold "
                      style={{ whiteSpace: "nowrap", borderTop: "none" }}
                    >
                      COUNTRY
                    </Th>
                  </Tr>
                </Thead>

                <Tbody>
                  {jobs.size > 0 &&
                    jobs.map((item) => {
                      return (
                        <Tr
                          onClick={this.showInfo(item)}
                          style={{ cursor: "pointer" }}
                        >
                          <Td
                            className="font-weight-bold text-primary p"
                            style={{ textAlign: "left" }}
                          >
                            {item.get("title")}
                          </Td>
                          <Td style={{ textAlign: "left" }}>
                            {" "}
                            <p className="td-alignment">
                              {" "}
                              {item.get("client")}{" "}
                            </p>
                          </Td>
                          <Td
                            className="job-expiry-date"
                            style={{ textAlign: "left" }}
                          >
                            {" "}
                            <p className="td-alignment">
                              {" "}
                              {moment(item.get("expires")).format(
                                "MMM DD, YYYY"
                              )}{" "}
                            </p>{" "}
                          </Td>
                          <Td
                            className="job-country"
                            style={{ textAlign: "left" }}
                          >
                            {" "}
                            <p className="td-alignment">
                              {" "}
                              {item.getIn(["country", "name"])}{" "}
                            </p>{" "}
                          </Td>
                        </Tr>
                      );
                    })}
                </Tbody>
              </Table>
            </div>
          </div>
          <div>
            <div className="col-12 mb-5 ">
              <button
                className="btn btn-block btn-primary mx-auto d-block text-center"
                style={{ maxWidth: "188px" }}
                onClick={this.moreJobs}
              >
                view more
              </button>
            </div>
          </div>
        </div>
        <GovernmentSlider />
      </Fragment>
    );
  }
}

const mapPropsToState = (state, props) => {
  const form_data = state.auth.get("form_data");
  const countries = state.auth.get("countries");
  const categories = state.auth.get("categories");
  const clients = state.auth.get("clients");
  const jobs = state.auth.get("jobs");
  const meta = state.auth.get("meta");
  return {
    form_data,
    countries,
    categories,
    clients,
    jobs,
    meta,
  };
};

export default withRouter(connect(mapPropsToState)(JobseekerJobSearch));
